<template>
  <div class="game-status" :style="setStyle()">
    <div class="text-data" v-if="gameCheckSwitch && checkGameText">
      <p class="text-data-box" v-if="isCorrect === 'correct' && gameData.item.checkGameText.positive">
        {{ gameData.item.checkGameText.positive }}
      </p>
      <p class="text-data-box" v-if="isCorrect === 'incorrect' && gameData.item.checkGameText.negative">
        {{ gameData.item.checkGameText.negative }}
      </p>
    </div>
    <transition
      name="custom-classes-transition"
      enter-active-class="animated bounceIn"
      leave-active-class="animated bounceOut"
    >
      <div
        v-if="!correctIcon"
        class="game-status-icon"
        v-show="gameCheckSwitch"
        :class="[{ 'correct-answer': isCorrect === 'correct' }, { 'wrong-answer': isCorrect === 'incorrect' }]"
      ></div>
    </transition>
    <transition
      name="custom-classes-transition"
      enter-active-class="animated bounceInRight"
      leave-active-class="animated bounceOutRight"
    >
      <img
        class="game-status-icon correct-answer-gif"
        :src="icon"
        style="width: 400px; height: 400px; position: absolute; top: -270px; left: -270px"
        v-show="gameCheckSwitch"
        v-if="correctIcon && isCorrect === 'correct'"
      />
      <div
        class="game-status-icon wrong-answer"
        v-show="gameCheckSwitch"
        v-if="correctIcon && isCorrect === 'incorrect'"
      ></div>
      <!-- <video
        autoplay
        muted
        id="myVideo"
        style="width: 100%; height: 100%"
        v-show="gameCheckSwitch && isCorrect === 'correct' && correctIcon != ''"
      >
        <source :src="correctIcon" type="video/mp4" /> -->
      <!-- </video> -->
    </transition>
  </div>
</template>

<script>
import { Howler } from 'howler';
import _ from 'lodash';
export default {
  name: 'tr-game-status',
  props: {
    gameStatus: {
      type: null,
      default: function () {
        return false;
      },
    },
  },
  data: function () {
    return {
      sound: null,
      audioStatus: false,
      icon: null,
      correctIcon: null,
      correctIconStatic: null,
    };
  },
  mounted() {
    let special = '';
    if (this.gameData.item.icon) {
      if (Array.isArray(this.gameData.item.icon)) special = _.shuffle(this.gameData.item.icon)[0];
      else special = this.gameData.item.icon;
    }
    try {
      this.correctIcon = require(`__mainSrcDir/assets/icons/both/gameInterface/statusCorrect${special}.gif`);
      this.correctIconStatic = require(`__mainSrcDir/assets/icons/both/gameInterface/statusCorrectStatic${special}.png`);
      if (this.correctIconStatic) {
        this.icon = this.correctIconStatic;
      } else {
        this.icon = this.correctIcon;
      }
    } catch (error) {
      console.log(
        '%cno gif (GIF IS NOT NECESSARY!) - error - TrGameStatus ',
        'font-weight: bold; background: red; color: white; padding: 0px 10px'
      );
    }
    // console.log('Panel Statusu');
  },
  methods: {
    checkSound() {
      console.log('GAME S: ' + this.$store.getters.gameCheckSwitch);
      if (!this.gameData.item.gameConfig.withoutCheck && !this.$store.getters.gameCheckCJS) {
        if (this.$store.getters.gameCheckSwitch) {
          if (this.isCorrect == 'correct') {
            console.log('TRUE!!!!');
            setTimeout(() => {
              if (
                typeof this.gameData.item.checkGameSound != 'undefined' &&
                this.gameData.item.checkGameSound != null &&
                this.gameData.item.checkGameSound.positive
              ) {
                this.icon = this.correctIcon;
                this.setAudioConfig(this.gameData.item.checkGameSound.positive);
              }
            }, 600);
          } else {
            console.log('FALSE!!!!');
            // setTimeout(() => {
            if (
              typeof this.gameData.item.checkGameSound != 'undefined' &&
              this.gameData.item.checkGameSound != null &&
              this.gameData.item.checkGameSound.negative
            )
              this.setAudioConfig(this.gameData.item.checkGameSound.negative);
            // }, 1000);
          }
        }
      }
    },
    setStyle() {
      let leftVal = 978;
      let rightVal = 978;
      if (this.checkGameText && this.gameCheckSwitch) {
        return { left: leftVal + 'px', width: '725px' };
      } else {
        rightVal = 3 * 80;
        if (this.blockResetAction) rightVal -= 80;
        if (this.blockCheck) rightVal -= 80;
        if (!this.multiStage) rightVal -= 80;
        return { right: rightVal + 'px', width: '125px' };
      }
    },
    giveMeImagePlease(path) {
      return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
    },
    setAudioConfig(audio) {
      if (Array.isArray(audio)) {
        // if (this.sound != null) {
        //   this.stopPlay();
        // }
        console.log('Randomowy końcowy motywator');
        let sound = new Howl({
          src: this.giveMeImagePlease(audio[Math.floor(Math.random() * audio.length)]),
          autoplay: true,
          loop: false,
          volume: 1,
          onend: () => {
            this.audioStatus = false;
            console.log('end');
            this.icon = this.correctIconStatic;
          },
          onpause: () => {
            this.audioStatus = false;
            console.log('end');
            this.icon = this.correctIconStatic;
          },
          onstop: () => {
            this.audioStatus = false;
            console.log('end');
            this.icon = this.correctIconStatic;
          },
          onplay: () => {
            this.audioStatus = true;
            console.log('sztart');
          },
        });
        return sound;
        // this.startPlay();
      }

      // if (this.sound != null) {
      //   this.stopPlay();
      // }
      let sound = new Howl({
        src: this.giveMeImagePlease(audio),
        autoplay: true,
        loop: false,
        volume: 1,
        onend: () => {
          this.audioStatus = false;
          console.log('end');
          this.icon = this.correctIconStatic;
        },
        onpause: () => {
          this.audioStatus = false;
          console.log('end');
          this.icon = this.correctIconStatic;
        },
        onstop: () => {
          this.audioStatus = false;
          console.log('end');
          this.icon = this.correctIconStatic;
        },
        onplay: () => {
          this.audioStatus = true;
          console.log('sztart');
        },
      });
      return sound;
      // this.startPlay();
    },
    startPlay() {
      if (!this.audioStatus) {
        this.sound.play();
      } else {
        this.stopPlay();
      }
    },
    stopPlay() {
      this.sound.stop();
    },
  },
  beforeDestroy() {
    if (this.sound) this.stopPlay();
  },
  watch: {
    gameCheckSwitch(newValue) {
      if (newValue) {
        setTimeout(() => {
          this.checkSound();
        }, 500);
      }
    },
  },
  computed: {
    checkGameText() {
      if (this.gameData.item.checkGameText) {
        return true;
      } else {
        return false;
      }
      return false;
    },
    isCorrect() {
      return this.gameStatus;
    },
    gameCheckSwitch() {
      return this.$store.getters.gameCheckSwitch;
    },
    blockCheckAction() {
      return this.$store.getters.blockCheckAction;
    },
    gameData() {
      return this.$store.getters.gameData;
    },
    blockCheck() {
      return this.$store.getters.blockCheck;
    },
    blockResetAction() {
      return this.$store.getters.blockResetAction;
    },
    multiStage() {
      return this.$store.getters.multiStageTest;
    },
    // gameStatusText() {
    //   return this.isCorrect ? 'dobrze' : 'źle';
    // },
    // icon() {
    //   return faStar;
    // }
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/iconColor';
@import '~@/assets/sass/animation';
@import '~@/assets/sass/variable';

.game-status {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 954px;
  // left: 1178px;
  // width: 525px;
  height: 125px;
  z-index: 12345;
  // font-size: 30px;
  // border: solid 1px black;
  // border-radius: 50%;
  // width: 10%;
  // height: 18%;
  .game-status-icon {
    display: flex;
    padding: 5%;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    width: 100%;
    height: 100%;
    .game-status-text {
      color: green;
      padding-left: 10%;
    }
  }
  .text-data {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    right: 130px;
    max-width: 580px;
    max-height: 125px;
    background: #e6e6e6;
    border-radius: 8px;
    .text-data-box {
      padding: 30px;
      margin: 0;
      font-size: 28px;
      font-family: $gameFontFamily;
    }
  }
  .correct-answer {
    background-image: url('~@/assets/icons/both/gameInterface/statusCorrect.png');
    background-position: right;
    // background-color: $iconStarFirstColor;
  }
  .wrong-answer {
    background-image: url('~@/assets/icons/both/gameInterface/statusWrong.png');
    background-position: right;
    // background-color: $iconStarFirstColor;
  }
  .unset-answer {
    opacity: 0;
    // background-image: url('~@/assets/icons/both/gameInterface/statusCorrect.png');
    background-position: right;
    // background-color: $iconStarFirstColor;
  }
  // .correct-answer-gif {
  //   width: 400px;
  //   height: 400px;
  //   // position: absolute;
  //   // top: calc(125px - 400px);
  //   // left: calc(125px - 400px);
  // }
}
/**
 * hack dla scali i przesuniecia z canvasem w cwiczeniach
 * @type {[type]}
 */

.hack-game-status {
  transform: translate(-50%, -50%) scale(0.7) !important;
  left: 58.5% !important;
  top: 66.8% !important;
}
</style>
